import React from 'react';
import { useLanguage } from '../i18n';

// Cleanup ticket (#76): the new-conversation screen is a clean, minimalist "Main
// Office" entry point — the three technical starter boxes (Write a Python
// function / Explain a concept / Debug code) were removed. Just the welcome.
//
// Personalized Welcome (#367): the heading addresses the user by name (the
// editable display name from User Settings #184 — `user.username`) instead of
// the generic "Welcome to PAI". `userName` arrives from useAuth's async
// profile fetch, so for the ~1-2s before it resolves (or for a caller that
// never passes one) this renders the plain, non-personalized "Welcome" rather
// than flashing "Welcome undefined" or any other wrong value.
const WelcomeScreen = ({ userName }) => {
    const { t } = useLanguage();
    const title = userName
        ? t('msgWelcomeTitle', 'Welcome {name}').replace('{name}', userName)
        : t('msgWelcomeTitleGeneric', 'Welcome');
    return (
        <div className="flex flex-col items-center justify-center h-full p-8">
            <div className="text-center">
                <h2 className="text-[28px] font-extrabold tracking-[-0.025em] text-white mb-2">{title}</h2>
                <p className="text-pai-meta text-[14.5px]">{t('msgWelcomeSubtitle', 'Start a conversation with your personal artificial intelligence (PAI)')}</p>
            </div>
        </div>
    );
};

export default WelcomeScreen;
